import { render } from "./PpcBidSettings.vue?vue&type=template&id=144e12c0&scoped=true"
import script from "./PpcBidSettings.vue?vue&type=script&lang=js"
export * from "./PpcBidSettings.vue?vue&type=script&lang=js"

import "./PpcBidSettings.vue?vue&type=style&index=0&id=144e12c0&scoped=true&lang=scss"
import "./PpcBidSettings.vue?vue&type=style&index=1&id=144e12c0&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-144e12c0"]])

export default __exports__